import { createContext, useCallback, useContext, useState } from 'react'
import type { ReactNode } from 'react'
import type { ContactChannel } from '../components/page'
import type { ContactFormData } from '../types/form-data.types'
import { buildInitialFormData } from '../types/form-data.types'

export type { ContactFormData, CallbackFormData, EmailFormData } from '../types/form-data.types'

interface FormDataContextValue {
  formData: ContactFormData
  updateFormData: (patch: Partial<ContactFormData>) => void
}

const FormDataContext = createContext<FormDataContextValue>({
  formData: buildInitialFormData('callback'),
  updateFormData: () => {},
})

interface FormDataProviderProps {
  channel: ContactChannel
  children: ReactNode
}

export const FormDataProvider = ({ channel, children }: FormDataProviderProps) => {
  const [formData, setFormData] = useState<ContactFormData>(() => buildInitialFormData(channel))

  const updateFormData = useCallback((patch: Partial<ContactFormData>) => {
    setFormData((prev) => ({ ...prev, ...patch }) as ContactFormData)
  }, [])

  return <FormDataContext.Provider value={{ formData, updateFormData }}>{children}</FormDataContext.Provider>
}

export const useFormData = (): FormDataContextValue => useContext(FormDataContext)
